import { useEffect, useState } from 'react';
import { useEvent } from '@/store';
import useCustomLinkActions from '@/store/custom-links/useCustomLinksActions';
import useBoletiaConfig from '@/hooks/useBoletiaConfig';

const alertMessages = {
  expired: {
    title: 'checkout.home.alerts.expired',
    message: 'checkout.home.alerts.expiredMsg',
    link: true,
  },
  inactive: {
    title: 'checkout.home.alerts.inactive',
    message: 'checkout.home.alerts.inactiveMsg',
    link: false,
  },
};

const linkAlertMessages = {
  inactive: {
    title: 'checkout.home.alerts.linkInactive',
    message: 'checkout.home.alerts.linkInactiveMsg',
    link: false,
  },
  expired: {
    title: 'checkout.home.alerts.linkExpired',
    message: 'checkout.home.alerts.linkExpiredMsg',
    link: false,
  },
  used: {
    title: 'checkout.home.alerts.linkUsed',
    message: 'checkout.home.alerts.linkUsedMsg',
    link: false,
  },
};



const allowedStatus = ['inactive', 'expired'];
const linkAllowedStatus = ['inactive', 'expired', 'used'];

export default function useEventAlerts(status) {
  const [alert, setAlert] = useState(null);
  const { event: { event: { id } } } = useEvent()

  const soldOutMsg = {
    title: id === 277730 ? 'La preventa ha terminado' : 'checkout.home.alerts.soldOut',
    message: id === 277730 ? 'La venta oficial inicia el 5 de agosto' : 'checkout.home.alerts.soldOutMsg',
    link: false,
  };

  const {
    customLink: { linkStatus, hasCustomLink },
  } = useCustomLinkActions();

  const getAlertStatus = () => {
    if (status === 'expired') {
      setAlert(alertMessages.expired);
      return;
    }

    if (status === 'soldout') {
      setAlert(soldOutMsg);
    }

    if (!hasCustomLink && allowedStatus.includes(status)) {
      setAlert(alertMessages[status]);
    }

    if (hasCustomLink && linkAllowedStatus.includes(linkStatus)) {
      setAlert(linkAlertMessages[linkStatus]);
    }


  };

  useEffect(() => {
    getAlertStatus();
  }, [status, hasCustomLink]);

  return { alert };
}
